import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LogoImg from "../../images/logo 01.png";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
const drawerWidth = 240;
// const navItems = ["Home", "About us", "How It Works", "Feature", "Pricing"];
const navItems = ["Home", "Features", "How It Works"];
// const navItems2 = ["Home", "About us", "How It Works", "Feature", "Pricing"];
const navItems2 = ["Home", "Features", "How It Works"];

function DrawerAppBarMain(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [storedVariable, setStoredVariable] = React.useState(null);
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  React.useEffect(() => {
    const isSignedin = localStorage.getItem("jwtToken");
    setStoredVariable(isSignedin);
  }, [storedVariable]);
  let path = storedVariable ? "/dashboard" : "/signinpin";
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        {/* <Box component="img" src={LogoImg} sx ={{height:"2.3rem"}} /> */}
        Blockpay
      </Typography>
      <Divider />
      <List>
        {navItems2.map((item) => (
          <ScrollLink
            to={item}
            spy={true}
            smooth={true}
            offset={-30}
            duration={500}
          >
            <ListItem key={item} disablePadding>
              <ListItemButton sx={{ textAlign: "center" }}>
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          </ScrollLink>
        ))}
        {!storedVariable && (
          <>
            <ListItem key="Join Blockpay" disablePadding>
              <ListItemButton
                sx={{ textAlign: "center" }}
                component={Link}
                to={path}
              >
                <ListItemText primary="Sign in" />
              </ListItemButton>
            </ListItem>
            <ListItem key="Join Blockpay" disablePadding>
              <ListItemButton
                sx={{ textAlign: "center" }}
                component={Link}
                to="/signup"
              >
                <ListItemText primary="Join Blockpay" />
              </ListItemButton>
            </ListItem>
          </>
        )}
        {storedVariable && (
          <ListItem key="Dashboard" disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              component={Link}
              to="/dashboard"
            >
              <ListItemText primary="Go to Dashboard" />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <CssBaseline />
      <AppBar position="fixed" component="nav" sx={{ background: "white" }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "block", lg: "none" },
              color: "black!important",
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "block", sm: "block" },
              textAlign: "left",
              "@media (max-width:1200px)": { textAlign: "center" },
              position: "relative",
              top: "4px",
            }}
          >
            <Box component="img" src={LogoImg} sx={{ height: "2.3rem" }} />
          </Typography>
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "none", lg: "block" },
            }}
          >
            {navItems.map((item) => (
              <ScrollLink
                to={item}
                spy={true}
                smooth={true}
                offset={-30}
                duration={500}
              >
                <Button
                  key={item}
                  sx={{
                    color: "#000",
                    textTransform: "none",
                    fontSize: "0.95rem",
                  }}
                >
                  {item}
                </Button>
              </ScrollLink>
            ))}

            {!storedVariable && (
              <>
                <Button
                  key="signup"
                  sx={{
                    color: "#000",
                    textTransform: "none",
                    fontSize: "0.95rem",
                  }}
                  component={Link}
                  to={path}
                >
                  Sign in
                </Button>
                <Button
                  key="signup"
                  sx={{
                    color: "#fff",
                    fontWeight: "400",
                    padding: "14px 20px",
                    borderRadius: "13px",
                    fontSize: "0.95rem",
                    ml: "1rem",
                    background:
                      "linear-gradient(90deg, #05B2FF 0%, #9340E2 100%)!important",
                    textTransform: "none",
                  }}
                  component={Link}
                  to="/signup"
                >
                  Join Blockpay
                </Button>
              </>
            )}
            {storedVariable && (
              <Button
                key="dashboard"
                sx={{
                  color: "#fff",
                  fontWeight: "400",
                  padding: "14px 20px",
                  borderRadius: "13px",
                  fontSize: "0.95rem",
                  ml: "1rem",
                  background:
                    "linear-gradient(90deg, #05B2FF 0%, #9340E2 100%)!important",
                  textTransform: "none",
                }}
                component={Link}
                to="/dashboard"
              >
                Go to Dashboard
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "block", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

DrawerAppBarMain.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBarMain;
